import React from 'react';
import './description.scss';

const Description = (props) => {

    const hexToRGBA = (hex, alpha) => {
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        return `rgba(${r},${g},${b},${alpha})`;
    };

    return(
        <div className='description blur-background' style={{top: `${props.y}px`,left: `${props.x}px`,"--color": hexToRGBA(props.color,1),"--color-thing": hexToRGBA(props.color,1)}}>
            {props.description}
        </div>    
    );
}
export default Description;